const CloseIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      d="M1.40141 13.6532L0.347656 12.5995L5.94766 6.99945L0.347656 1.39945L1.40141 0.345703L7.00141 5.9457L12.6014 0.345703L13.6552 1.39945L8.05516 6.99945L13.6552 12.5995L12.6014 13.6532L7.00141 8.0532L1.40141 13.6532Z"
      fill="#535862"
    />
  </svg>
);

export default CloseIcon;
